<template>
  <div>
    <div slot="title">
      <h1>Cálculo de días hábiles</h1>
      <h3>Capture el periodo de días</h3>
    </div>
    <br />
    <div class="container-fluid">
      <fieldset class="row area">
        <div class="form-group">
          <div class="row">
             
            
            <div class="row form-group-h col-4">
              <label class="col-form-label offset-md-3">Fecha de inicial: </label>
              <input id="calendarioFechaInicial" v-model="fechaInicial" name="calendarioFechaInicial" type="date" class=" row form-control col-10 offset-md-1" />
            </div>
            

            
            <div class="row form-group-h col-4">
              <label class="col-form-label offset-md-4">Fecha final: </label>
              <input id="calendarioFechaFinal" v-model="fechaFinal" name="calendarioFechaFinal" type="date" class="row form-control col-10 offset-md-2"/>
            </div>
            

            
            <div class="form-group-h col-md-6">
              <button v-on:click="obtenerDiasHabiles()" id="btnConsulta" class="btn btn-primary">Consultar</button>
            </div> 

          </div>

        </div>
        <br />
        <div class="alert alert-dark" role="alert">
          <dl class="row">
            <dt class="col-1">Nota</dt>
            <dd class="col-11">Se considera inclusive el día de inicio como parte del conteo.</dd>

            <dt class="col-1"> </dt>
            <dd class="col-11">Los días sábado y domingo están considerados como días inhábiles.</dd>
          </dl>
        </div>

      </fieldset>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import api from '../../../../static/js/api.js'
  import comun from '../../../../static/js/comun.js'
  import enumeraciones from '../../../../static/js/enumeraciones.js'

  export default {
    data:
      function() {
    return {
      fechaInicial: moment().startOf('year').format('YYYY-MM-DD'),
      fechaFinal: moment().endOf('year').format('YYYY-MM-DD'),
      totalDias: 0,
      error: null
    }
  }
    ,
    methods: {
      obtenerDiasHabiles() {        
        var peticion = {
          "esPrueba": false,
          "AnioActual": new Date().getFullYear(),
          "CalendarioFechaInicial": moment(this.fechaInicial, 'YYYY-MM-DD').subtract(1, 'days').format(),
          "CalendarioFechaFinal": this.fechaFinal };        
        axios.post(api.conexion + api.DiasHabiles.funcion.GetDiasHabiles, peticion).then(response => {
          if (response.data.SiHayError == false) {
            this.totalDias = response.data.TotalDiasHabiles;
            comun.mensajeDeAlerta("Hay "+this.totalDias+" días hábiles.",null,null);
            // $('#modalCalculaDiasInhabiles').modal('show');
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
            // this.error = response.data.Error.Mensaje;
            // $('#modalInvalidezAlerta').modal('show');
          }
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
        }
      }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DiasHabiles/Consultas/DiasHabiles.vue